<template>
  <div :class="rootClass" :style="{ background: category.color }">
    <NuxtLink
      v-slot="{ href, navigate }"
      :to="{ name: 'war-room-categories-categorySlug-posts', params: { categorySlug: category.slug } }"
      custom
    >
      <a :href="href" class="war-room-category-badge__link" data-test="post_preview_category" @click.stop="navigate">
        <WarRoomLogoIcon v-if="isOfficial" class="war-room-category-badge__icon" />
        <span>{{ category.title }}</span>
      </a>
    </NuxtLink>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import WarRoomLogoIcon from './images/war-room-logo.vue.svg';
import type { IPost, IPostCategory } from '@/types/community';
import { categoryNames } from '~/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';

export default Vue.extend({
  name: 'WarRoomCategoryBadge',
  components: {
    WarRoomLogoIcon,
  },
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
  computed: {
    isOfficial(): boolean {
      return this.category.slug === categoryNames.OFFICIAL;
    },
    rootClass(): Record<string, boolean> {
      return {
        'war-room-category-badge': true,
        'war-room-category-badge--official': this.isOfficial,
      };
    },
    category(): IPostCategory {
      return this.post.category as IPostCategory;
    },
  },
});
</script>

<style scoped lang="scss">
.war-room-category-badge {
  $this: &;

  display: flex;
  align-items: center;
  padding: 3px 6px;
  border-radius: 4px;
  cursor: pointer;
  background-color: var(--theme-color-over-card);

  @include border-hover(border);

  &--official {
    #{$this}__link {
      color: rgba(var(--white));
      opacity: 1;

      &:hover {
        color: rgba(var(--white));
      }
    }
  }

  @include mq('md') {
    padding: 5px 8px;
  }

  &__link {
    @include caption1;

    text-decoration: none;
    display: flex;
    align-items: center;
    color: rgba(var(--black));

    span {
      opacity: 0.7;
    }
  }

  &__name {
    @include subhead;

    font-weight: normal;
    color: var(--theme-color-text);

    &:hover {
      color: rgba(var(--theme-text-rgb), 0.85);
    }
  }

  &__icon {
    margin-right: 5px;
  }
}
</style>
